@if (isLoading) {
  <div class="spinner-overlay">
    <mat-spinner></mat-spinner>
  </div>
}

<h1 class="title">Subsample - Capillary Pressure Simulation</h1>
<mat-card class="simulator-card">
  <div class="simulator-content">
    <div class="simulator-layout">
      <div class="simulator-column">
        <app-rock-preview
          [thumbnailUrl]="thumbnailUrl"
          [totalPorosity]="totalPorosity"
          [showLegend]="true"
          [showPorosity]="!!thumbnailUrl">
        </app-rock-preview>
      </div>

      <div class="simulator-column">
        <mat-expansion-panel [expanded]="true">
          <mat-expansion-panel-header>
            <mat-panel-title>Select Segmented Rock Image</mat-panel-title>
          </mat-expansion-panel-header>

          <div class="input-row">
            <div class="flex">
              <mat-form-field appearance="outline">
                <mat-label>Segmented Rock Image file</mat-label>
                <input matInput disabled [value]="fileName | removeExtension" />
              </mat-form-field>
              <button
                class="btn btn-primary upload-btn"
                (click)="selectRockFileName()"
                >
                <mat-icon>search</mat-icon>
              </button>
            </div>
          </div>
        </mat-expansion-panel>

        <mat-expansion-panel [expanded]="true">
          <mat-expansion-panel-header>
            <mat-panel-title>Simulation name</mat-panel-title>
          </mat-expansion-panel-header>

          <form [formGroup]="simulationNameForm" class="input-form">
            <mat-form-field appearance="outline">
              <mat-label>Simulation name</mat-label>
              <input matInput [formControlName]="'name'" />
              @if (nameControl.hasError('maxlength')) {
                <mat-error>
                  Simulation name can't contain more than 256 characters.
                </mat-error>
              }
            </mat-form-field>
          </form>
        </mat-expansion-panel>

        <mat-expansion-panel [expanded]="true">
          <mat-expansion-panel-header>
            <mat-panel-title>Simulation Direction</mat-panel-title>
          </mat-expansion-panel-header>

          <form [formGroup]="simulationDirectionsForm">
            <div class="input-row">
              <span>Simulation Direction</span>
              <mat-radio-group class="direction-options" formControlName="selectedDirection">
                <mat-radio-button value="xDirection">X</mat-radio-button>
                <mat-radio-button value="yDirection">Y</mat-radio-button>
                <mat-radio-button value="zDirection">Z</mat-radio-button>
              </mat-radio-group>
            </div>
          </form>
        </mat-expansion-panel>

        <mat-expansion-panel [expanded]="true">
          <mat-expansion-panel-header>
            <mat-panel-title>Interfacial tension (N/m)</mat-panel-title>
          </mat-expansion-panel-header>

          <form [formGroup]="interfacialTensionForm" class="input-form">
            <mat-form-field appearance="outline">
              <mat-label>Interfacial tension</mat-label>
              <input matInput type="number" [formControlName]="'interfacialTension'" />
              @if (interfacialTension.hasError('required')) {
                <mat-error>
                  Interfacial tension is required.
                </mat-error>
              }
              @if (interfacialTension.hasError('min')) {
                <mat-error>
                  Value can't be negative.
                </mat-error>
              }
            </mat-form-field>
          </form>
        </mat-expansion-panel>

        <mat-expansion-panel [expanded]="true">
          <mat-expansion-panel-header>
            <mat-panel-title>Contact Angle cosine</mat-panel-title>
          </mat-expansion-panel-header>

          <form [formGroup]="contactAngleForm" class="input-form">
            <div class="optional-form-field">
              <mat-form-field appearance="outline" class="contact-angle-input">
                <mat-label>Primary drainage (PD)</mat-label>
                <input matInput type="number" [formControlName]="'primaryDrainage'" />
                @if (primaryDrainage.hasError('required')) {
                  <mat-error>
                    Primary drainage is required.
                  </mat-error>
                }
                @if (primaryDrainage.hasError('min') || primaryDrainage.hasError('max')) {
                  <mat-error>
                    Value should be in range from -1 to 1.
                  </mat-error>
                }
              </mat-form-field>
              <mat-checkbox
                [formControlName]="'simulatePrimaryDrainage'"
                class="simulation-checkbox"
                >Simulate</mat-checkbox
                >
              </div>

              <div class="optional-form-field">
                <mat-form-field appearance="outline" class="contact-angle-input">
                  <mat-label>First imbibition (FI)</mat-label>
                  <input matInput type="number" [formControlName]="'firstImbibition'" />
                  @if (firstImbibition.hasError('min') || firstImbibition.hasError('max')) {
                    <mat-error>
                      Value should be in range from -1 to 1.
                    </mat-error>
                  }
                </mat-form-field>
                <mat-checkbox
                  [formControlName]="'simulateFirstImbibition'"
                  class="simulation-checkbox"
                  >Simulate</mat-checkbox
                  >
                </div>

                <div class="optional-form-field">
                  <mat-form-field appearance="outline" class="contact-angle-input">
                    <mat-label>Secondary drainage (SD)</mat-label>
                    <input matInput type="number" [formControlName]="'secondaryDrainage'" />
                    @if (secondaryDrainage.hasError('min') || secondaryDrainage.hasError('max')) {
                      <mat-error>
                        Value should be in range from -1 to 1.
                      </mat-error>
                    }
                  </mat-form-field>
                  <mat-checkbox
                    [formControlName]="'simulateSecondaryDrainage'"
                    class="simulation-checkbox"
                    >Simulate</mat-checkbox
                    >
                  </div>
                </form>
              </mat-expansion-panel>

              <div class="controls">
                <button
                  class="btn btn-primary btn-big submit-btn"
                  id="run-simulation-btn"
                  type="button"
            [disabled]="
              isLoading ||
              !isSimulationInputValid()
            "
                  (click)="runSimulation()"
                  color="primary"
                  >
                  Run simulation
                </button>
              </div>
            </div>
          </div>
        </div>
      </mat-card>
